/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in 
*                 part without express written permission of Honeywell Inc. 
*                 is prohibited.
*
* Name          : InvalidWirelessProduct.tsx
* 
* Project Title : Checkout
*  
* Description   : Initial version
* 
* Company       : Honeywell Technology Solutions , Hyderabad
* 
* @Author       : Suresh Jaladi - E807958
* 
* @Date         : Dec 05, 2019
*
* @Version      : Version 1.0
*
* By            : Suresh Jaladi - E807958
* On            : Dec 06, 2019
* Description   : ASDS-1811
*
* By            	: Snigdha
* On            	: Feb 10, 2019
* Description      : ASDS-2268
******************************************************************************/
import * as React from 'react';
import { Modal, Grid, Card, Button, Icon } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import 'modules/checkout/ReviewOrder/reviewOrder.css';
import CheckoutConstants from '../../constants/checkout-constants';

interface WirelessDeleteProductConfI {
    open: boolean;
    onClose: Function,
    productId: string
}


function InvalidWirelessProduct(props: WirelessDeleteProductConfI) {
    return (
        <Modal size="large" closeIcon={true} open={props.open} onClose={() => props.onClose()} closeOnDimmerClick={false}>
            <Modal.Header>
                <span className="dap-modal-header">Unable To Add Product To Your Cart!</span>
            </Modal.Header>
            <Modal.Content>
                <React.Fragment>
                    <Card>
                        <Card.Content>
                            <Grid.Row>
                                <Grid.Column width={1}>
                                    <Icon root="common" name="badge-warning" size="large" color="red" />
                                </Grid.Column>
                                {CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_ID === props.productId && <Grid.Column width={11}>
                                    You need to be subscribed to DLMU-W to add this product into the cart.
                                </Grid.Column>}
                                {CheckoutConstants.REMOTE_TERMINAL_SERVICES_PRODUCT_ID === props.productId && <Grid.Column width={11}>
                                    You need to be subscribed to Fault Analyzer to add this product into the cart.
                                </Grid.Column>}
                            </Grid.Row>
                        </Card.Content>
                    </Card>
                </React.Fragment>
            </Modal.Content>
            <Modal.Footer>
                <Button type="primary" className="co-primary-button" content="CLOSE" onClick={() => { props.onClose(); }} />

            </Modal.Footer>
        </Modal>
    );
}

export default InvalidWirelessProduct;